var map = {
	"./americano.png": "5b0a",
	"./aussie.png": "a101",
	"./baby-ricks.png": "4b4e",
	"./baked-potato.png": "6923",
	"./bone-in.png": "4b9a",
	"./cappuchino.png": "bac0",
	"./chicken-tortilla.png": "b10b",
	"./chocolate-thunder.png": "62a3",
	"./droven-ribs.png": "50ea",
	"./gold-coast.png": "4a23",
	"./grilled-shrirmp.png": "4457",
	"./grillef-chicken.png": "db59",
	"./latte.png": "7a5f",
	"./menu1.png": "b7fa",
	"./mocha.png": "cf25",
	"./onion.png": "a263",
	"./outbreak-center.png": "f9f3",
	"./perfectly-grilled-salmon.png": "d305",
	"./ribeye.png": "cd30",
	"./salted-creame.png": "07c4",
	"./the-stack.png": "f044",
	"./victoria-filet.png": "9762"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2143";